import { Link } from "react-router-dom";
import SmartLink from "@/components/SmartLink";
import Logo, { Sparkle } from "@/components/Logo";
import SocialLinks from "@/components/SocialLinks";
import IloveMeIcon from "@/components/IloveMeIcon";
import { ILOVEME_URL, waLink } from "@/lib/site";
import { trackEvent } from "@/lib/tracking";

const GROUPS = [
    {
        title: "Soluções",
        links: [
            { label: "Lei do Salão Parceiro", to: "/solucoes" },
            { label: "Gestão Tributária", to: "/solucoes" },
            { label: "BPO Financeiro", to: "/solucoes" },
            { label: "Abertura e Regularização", to: "/solucoes" },
            { label: "ilove.me", to: ILOVEME_URL },
        ],
    },
    {
        title: "Perfis",
        links: [
            { label: "Salões de Beleza", to: "/salao-de-beleza" },
            { label: "Barbearias", to: "/barbearia" },
            { label: "Esmalterias", to: "/esmalteria" },
            { label: "Spas", to: "/spa" },
            { label: "Clínicas de Estética", to: "/para-quem" },
            { label: "Profissionais da Beleza", to: "/para-quem" },
        ],
    },
    {
        title: "Institucional",
        links: [
            { label: "Sobre Nós", to: "/sobre" },
            { label: "Contato", to: "/contato" },
            { label: "Política de Privacidade", to: "/politica-de-privacidade" },
        ],
    },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative overflow-hidden bg-[#08104F] text-[#F3EDE6]">
            <div className="pointer-events-none absolute inset-0 hero-grid-lines opacity-40" />
            <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8 sm:pt-24">
                <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
                    <div>
                        <Link to="/" aria-label="Contabeleza - Início" className="inline-block">
                            <Logo variant="white" className="h-8 w-auto" />
                        </Link>
                        <p className="mt-6 max-w-sm text-base leading-relaxed text-[#B2D0FF]">
                            A contabilidade especialista na Lei do Salão Parceiro. Gestão, conformidade e
                            tecnologia para o mercado da beleza.
                        </p>
                        <a
                            href={waLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="btn-footer-whatsapp"
                            onClick={() => trackEvent("whatsapp_click", { location: "footer" })}
                            className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#B2D0FF]/30 px-5 py-2.5 text-sm font-medium text-[#F3EDE6] transition-colors duration-200 hover:border-[#B2D0FF] hover:bg-white/5"
                        >
                            Chamar no WhatsApp
                        </a>
                        <div className="mt-9">
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#B2D0FF]/70">
                                Siga a Contabeleza
                            </p>
                            <div className="mt-4">
                                <SocialLinks />
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
                        {GROUPS.map((group) => (
                            <div key={group.title}>
                                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#B2D0FF]/70">
                                    {group.title}
                                </p>
                                <ul className="mt-4 space-y-2.5">
                                    {group.links.map((link) => (
                                        <li key={link.label}>
                                            <SmartLink
                                                to={link.to}
                                                className="text-sm text-[#F3EDE6]/75 transition-colors duration-150 hover:text-white"
                                            >
                                                {link.label === "ilove.me" ? <IloveMeIcon className="inline-flex items-center gap-1" /> : link.label}
                                            </SmartLink>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
                    <p className="flex items-center gap-2 text-xs text-[#F3EDE6]/50">
                        <Sparkle className="h-3.5 w-3.5" />
                        © {new Date().getFullYear()} Contabeleza. Todos os direitos reservados.
                    </p>
                    <p className="max-w-xl text-xs leading-relaxed text-[#F3EDE6]/40">
                        Assessoria contábil especializada no mercado da beleza. Especialistas na Lei nº 13.352/2016
                        (Lei do Salão Parceiro). <IloveMeIcon className="inline-flex items-center gap-1 align-baseline" />.
                    </p>
                </div>
            </div>
        </footer>
    );
}
